import React, { useContext } from "react";
import "./Call.css";
import { IoMdClose } from "react-icons/io";
import { UserActivityContext } from "../../../context/UserActivity";

const Call = () => {
  const { setDisplayCall } = useContext(UserActivityContext);

  return (
    <div className="overlay">
      <div className="call-container">
        <IoMdClose
          className="call-close"
          onClick={() => setDisplayCall(false)}
        />
        <h2 className="call-title">Call for Papers</h2>
        <div className="call-wrapper">
          <a
            href={require("../../../assets/callPDF/CallCAT.pdf")}
            download={"CallCAT.pdf"}
            className="call-link"
          >
            Català
          </a>
          <a
            href={require("../../../assets/callPDF/CallCAST.pdf")}
            download={"CallCAST.pdf"}
            className="call-link"
          >
            Castellano
          </a>
          <a
            href={require("../../../assets/callPDF/CallENG.pdf")}
            download={"CallENG.pdf"}
            className="call-link"
          >
            English
          </a>
        </div>
      </div>
    </div>
  );
};

export default Call;
